var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lh-1 wrap" },
    [
      _c(
        "div",
        { staticClass: "flex items-center pad30-tb" },
        [
          _c("div", { staticClass: "f48 flex1" }, [_vm._v("进货车")]),
          _c(
            "el-steps",
            { staticClass: "steps", attrs: { active: 2, "align-center": "" } },
            [
              _c("el-step", { attrs: { title: "我的进货车" } }),
              _c("el-step", { attrs: { title: "填写核对订单" } }),
              _c("el-step", { attrs: { title: "成功提交订单" } })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "f18 pad30-t gray9" }, [_vm._v("填写核对订单")]),
      _vm._m(0),
      _c("div", { staticClass: "mar30-b block" }, [
        _c("div", { staticClass: "lin_50 f16 gray9 pad30-lr b_gray2" }, [
          _vm._v("收货人信息")
        ]),
        _c("div", { staticClass: "flex justify-between pad30" }, [
          _vm._m(1),
          _c(
            "div",
            {
              staticClass:
                "text-center flex1 flex flex-column justify-center btns"
            },
            [
              _c("router-link", { staticClass: "blue", attrs: { to: "#" } }, [
                _vm._v("修改地址")
              ]),
              _c(
                "router-link",
                {
                  staticClass: "b_gray2 mar20-t add-address",
                  attrs: { to: "#" }
                },
                [_vm._v("新增地址")]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "mar30-b block" },
        [
          _c("div", { staticClass: "lin_50 f16 pad30-lr" }, [
            _vm._v("商家：河北农信精品店")
          ]),
          _vm._m(2),
          _vm._m(3),
          _c("div", { staticClass: "pad30" }, [
            _c(
              "div",
              { staticClass: "flex f16" },
              [
                _c("div", { staticClass: "pad30-r" }, [_vm._v("开具发票")]),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "1" },
                    model: {
                      value: _vm.invoice,
                      callback: function($$v) {
                        _vm.invoice = $$v
                      },
                      expression: "invoice"
                    }
                  },
                  [_c("span", { staticClass: "f16 gray3" }, [_vm._v("是")])]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "2" },
                    model: {
                      value: _vm.invoice,
                      callback: function($$v) {
                        _vm.invoice = $$v
                      },
                      expression: "invoice"
                    }
                  },
                  [_c("span", { staticClass: "f16 gray3" }, [_vm._v("否")])]
                )
              ],
              1
            ),
            _vm.invoice === "1"
              ? _c("div", { staticClass: "flex flex-column mar20-t" }, [
                  _c(
                    "div",
                    { staticClass: "b_gray2 flex gray9 border invoice-tabs" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pointer pad10-lr item",
                          class: { active: _vm.invoiceActive === 1 },
                          on: {
                            click: function($event) {
                              return _vm.invoiceChange(1)
                            }
                          }
                        },
                        [_vm._v("纸质发票")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pointer pad10-lr item",
                          class: { active: _vm.invoiceActive === 2 },
                          on: {
                            click: function($event) {
                              return _vm.invoiceChange(2)
                            }
                          }
                        },
                        [_vm._v("电子发票")]
                      )
                    ]
                  ),
                  _vm.invoiceActive === 1
                    ? _c(
                        "div",
                        { staticClass: "border mar20-t pad30 invoice-content" },
                        [_vm._m(4), _vm._m(5)]
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "border flex mar20-t pad30 invoice-content"
                        },
                        [
                          _vm._m(6),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-column items-center justify-center fn"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "pointer red",
                                  on: {
                                    click: function($event) {
                                      _vm.invoiceListVisible = true
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pointer text-center mar20-t add",
                                  on: {
                                    click: function($event) {
                                      _vm.invoiceVisible = true
                                    }
                                  }
                                },
                                [_vm._v("新增")]
                              )
                            ]
                          )
                        ]
                      )
                ])
              : _vm._e()
          ]),
          _c(
            "el-collapse",
            {
              staticClass: "pad30-lr discount-collapse",
              model: {
                value: _vm.discountActive,
                callback: function($$v) {
                  _vm.discountActive = $$v
                },
                expression: "discountActive"
              }
            },
            [
              _c(
                "el-collapse-item",
                {
                  staticClass: "f16",
                  attrs: { title: "使用优惠券", name: "1" }
                },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "discount-tabs",
                      attrs: { type: "card" },
                      model: {
                        value: _vm.discountTabs,
                        callback: function($$v) {
                          _vm.discountTabs = $$v
                        },
                        expression: "discountTabs"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "店铺券", name: "1" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-wrap pad30-lr pad30-b" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mar30-r mar30-t pointer item select"
                                },
                                [
                                  _c("div", { staticClass: "pad20 white" }, [
                                    _c("div", [
                                      _c("span", { staticClass: "arial f20" }, [
                                        _vm._v("¥20")
                                      ]),
                                      _c("span", { staticClass: "mar5-l" }, [
                                        _vm._v("满200")
                                      ])
                                    ]),
                                    _c("div", { staticClass: "mar20-t" }, [
                                      _vm._v("有效期至2020-12-31")
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "pad20-l pad10-t f12" },
                                    [_vm._v("全部货品可用")]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mar30-r mar30-t pointer item disable"
                                },
                                [
                                  _c("div", { staticClass: "pad20 white" }, [
                                    _c("div", [
                                      _c("span", { staticClass: "arial f20" }, [
                                        _vm._v("¥20")
                                      ]),
                                      _c("span", { staticClass: "mar5-l" }, [
                                        _vm._v("满200")
                                      ])
                                    ]),
                                    _c("div", { staticClass: "mar20-t" }, [
                                      _vm._v("有效期至2020-12-31")
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "pad20-l pad10-t f12" },
                                    [_vm._v("全部货品可用")]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "平台券", name: "2" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-wrap pad30-lr pad30-b" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mar30-r mar30-t pointer item select"
                                },
                                [
                                  _c("div", { staticClass: "pad20 white" }, [
                                    _c("div", [
                                      _c("span", { staticClass: "arial f20" }, [
                                        _vm._v("¥20")
                                      ]),
                                      _c("span", { staticClass: "mar5-l" }, [
                                        _vm._v("满200")
                                      ])
                                    ]),
                                    _c("div", { staticClass: "mar20-t" }, [
                                      _vm._v("有效期至2020-12-31")
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "pad20-l pad10-t f12" },
                                    [_vm._v("全部货品可用")]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mar30-r mar30-t pointer item disable"
                                },
                                [
                                  _c("div", { staticClass: "pad20 white" }, [
                                    _c("div", [
                                      _c("span", { staticClass: "arial f20" }, [
                                        _vm._v("¥20")
                                      ]),
                                      _c("span", { staticClass: "mar5-l" }, [
                                        _vm._v("满200")
                                      ])
                                    ]),
                                    _c("div", { staticClass: "mar20-t" }, [
                                      _vm._v("有效期至2020-12-31")
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "pad20-l pad10-t f12" },
                                    [_vm._v("全部货品可用")]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex lh-40 b_gray2" }, [
                    _c("div", { staticClass: "pad30-lr" }, [
                      _vm._v("金额抵用"),
                      _c("span", { staticClass: "f16 red" }, [_vm._v("¥20.00")])
                    ]),
                    _c("div", [_vm._v("使用优惠券1张，优惠20.00元")])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._m(7)
        ],
        1
      ),
      _c("div", { staticClass: "mar30-b block" }, [
        _c("div", { staticClass: "lin_50 f16 pad30-lr" }, [
          _vm._v("商家：河北农信精品店")
        ]),
        _vm._m(8),
        _vm._m(9),
        _c("div", { staticClass: "pad30" }, [
          _c(
            "div",
            { staticClass: "flex f16" },
            [
              _c("div", { staticClass: "pad30-r" }, [_vm._v("开具发票")]),
              _c(
                "el-radio",
                {
                  attrs: { label: "1" },
                  model: {
                    value: _vm.invoice,
                    callback: function($$v) {
                      _vm.invoice = $$v
                    },
                    expression: "invoice"
                  }
                },
                [_c("span", { staticClass: "f16 gray3" }, [_vm._v("是")])]
              ),
              _c(
                "el-radio",
                {
                  attrs: { label: "2" },
                  model: {
                    value: _vm.invoice,
                    callback: function($$v) {
                      _vm.invoice = $$v
                    },
                    expression: "invoice"
                  }
                },
                [_c("span", { staticClass: "f16 gray3" }, [_vm._v("否")])]
              )
            ],
            1
          ),
          _vm.invoice === "1"
            ? _c("div", { staticClass: "flex flex-column mar20-t" }, [
                _c(
                  "div",
                  { staticClass: "b_gray2 flex gray9 border invoice-tabs" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pointer pad10-lr item",
                        class: { active: _vm.invoiceActive === 1 },
                        on: {
                          click: function($event) {
                            return _vm.invoiceChange(1)
                          }
                        }
                      },
                      [_vm._v("纸质发票")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "pointer pad10-lr item",
                        class: { active: _vm.invoiceActive === 2 },
                        on: {
                          click: function($event) {
                            return _vm.invoiceChange(2)
                          }
                        }
                      },
                      [_vm._v("电子发票")]
                    )
                  ]
                ),
                _vm.invoiceActive === 1
                  ? _c(
                      "div",
                      { staticClass: "border mar20-t pad30 invoice-content" },
                      [_vm._m(10), _vm._m(11)]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "border flex mar20-t pad30 invoice-content"
                      },
                      [
                        _vm._m(12),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-column items-center justify-center fn"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "pointer red",
                                on: {
                                  click: function($event) {
                                    _vm.invoiceListVisible = true
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "pointer text-center mar20-t add",
                                on: {
                                  click: function($event) {
                                    _vm.invoiceVisible = true
                                  }
                                }
                              },
                              [_vm._v("新增")]
                            )
                          ]
                        )
                      ]
                    )
              ])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "f16 pad30 block mar30-b mode" }, [
        _c("div", { staticClass: "flex items-center mar30-b" }, [
          _c("div", { staticClass: "mar30-r" }, [_vm._v("配送方式")]),
          _c("div", { staticClass: "text-center f14 mar30-r btn selected" }, [
            _vm._v("卖家配送")
          ]),
          _c(
            "div",
            {
              staticClass: "text-center f14 pointer btn",
              on: {
                click: function($event) {
                  _vm.shippingAddressVisible = true
                }
              }
            },
            [_vm._v("查看配送地址")]
          )
        ]),
        _vm._m(13)
      ]),
      _vm._m(14),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "查看地址",
            visible: _vm.shippingAddressVisible,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.shippingAddressVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "f16 pad5-b" }, [_vm._v("支持的配送区域")]),
          _c("div", { staticClass: "flex flex-wrap" }, [
            _c("div", { staticClass: "mar10-t mar20-r" }, [_vm._v("北京市")]),
            _c("div", { staticClass: "mar10-t mar20-r" }, [_vm._v("天津市")]),
            _c("div", { staticClass: "mar10-t mar20-r" }, [_vm._v("河北省")]),
            _c("div", { staticClass: "mar10-t mar20-r" }, [_vm._v("上海市")])
          ]),
          _c("div", { staticClass: "mar30-t pad5-b f16" }, [
            _vm._v("支持的自提地址")
          ]),
          _c("div", { staticClass: "mar10-t" }, [
            _vm._v("北京市东城区东城花园112室")
          ]),
          _c("div", { staticClass: "mar10-t" }, [
            _vm._v("北京市东城区东城花园112室")
          ]),
          _c("div", { staticClass: "mar10-t" }, [
            _vm._v("北京市东城区东城花园112室")
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增开票信息",
            visible: _vm.invoiceVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.invoiceVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "invoiceForm",
              staticClass: "pad30-r",
              attrs: {
                size: "small",
                model: _vm.invoiceForm,
                rules: _vm.invoiceRules,
                "label-width": "115px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "抬头", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写个人或企业名称" },
                    model: {
                      value: _vm.invoiceForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceForm, "name", $$v)
                      },
                      expression: "invoiceForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "纳税人识别号", prop: "id" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写个人或企业名称" },
                    model: {
                      value: _vm.invoiceForm.id,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceForm, "id", $$v)
                      },
                      expression: "invoiceForm.id"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单位地址", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写单位注册地址" },
                    model: {
                      value: _vm.invoiceForm.address,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceForm, "address", $$v)
                      },
                      expression: "invoiceForm.address"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "注册电话", prop: "tel" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写单位注册电话" },
                    model: {
                      value: _vm.invoiceForm.tel,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceForm, "tel", $$v)
                      },
                      expression: "invoiceForm.tel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开户行", prop: "bank" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写开户银行" },
                    model: {
                      value: _vm.invoiceForm.bank,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceForm, "bank", $$v)
                      },
                      expression: "invoiceForm.bank"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "银行账户", prop: "account" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写银行账号" },
                    model: {
                      value: _vm.invoiceForm.account,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceForm, "account", $$v)
                      },
                      expression: "invoiceForm.account"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "mar20-r",
                  on: {
                    click: function($event) {
                      _vm.invoiceVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitInvoiceForm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "invoice-list",
          attrs: {
            title: "开票信息",
            visible: _vm.invoiceListVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.invoiceListVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "pointer border pad10 radius5 mar20-b item" },
            [
              _c("div", { staticClass: "flex relative flex-wrap" }, [
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("发票抬头：2630022541")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("纳税人识别号：W7856456456456456LJ7")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("单位地址：北京市海淀区中关村大厦C座12层1205")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("注册电话：102-4568956")
                ]),
                _c("div", { staticClass: "w50" }, [
                  _vm._v("开户行：北京市海淀区中关村大厦C座12层")
                ]),
                _c("div", { staticClass: "w50" }, [
                  _vm._v("银行账户：7895 5548 5787 587")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center border-l pad20-lr f16 absolute bg-white del"
                  },
                  [_vm._v("删除")]
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "pointer border pad10 radius5 mar20-b item active" },
            [
              _c("div", { staticClass: "flex relative flex-wrap" }, [
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("发票抬头：2630022541")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("纳税人识别号：W7856456456456456LJ7")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("单位地址：北京市海淀区中关村大厦C座12层1205")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("注册电话：102-4568956")
                ]),
                _c("div", { staticClass: "w50" }, [
                  _vm._v("开户行：北京市海淀区中关村大厦C座12层")
                ]),
                _c("div", { staticClass: "w50" }, [
                  _vm._v("银行账户：7895 5548 5787 587")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center border-l pad20-lr f16 absolute bg-white del"
                  },
                  [_vm._v("删除")]
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "pointer border pad10 radius5 mar20-b item" },
            [
              _c("div", { staticClass: "flex relative flex-wrap" }, [
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("发票抬头：2630022541")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("纳税人识别号：W7856456456456456LJ7")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("单位地址：北京市海淀区中关村大厦C座12层1205")
                ]),
                _c("div", { staticClass: "mar10-b w50" }, [
                  _vm._v("注册电话：102-4568956")
                ]),
                _c("div", { staticClass: "w50" }, [
                  _vm._v("开户行：北京市海淀区中关村大厦C座12层")
                ]),
                _c("div", { staticClass: "w50" }, [
                  _vm._v("银行账户：7895 5548 5787 587")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center border-l pad20-lr f16 absolute bg-white del"
                  },
                  [_vm._v("删除")]
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "mar20-r",
                  on: {
                    click: function($event) {
                      _vm.invoiceListVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.invoiceListVisible = false
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "f18 flex mar30-tb" }, [
      _c("div", [_vm._v("当前以个人身份下单：")]),
      _c("div", { staticClass: "pointer switch" }, [_vm._v("张张张")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "f16 info" }, [
      _c("div", { staticClass: "mar30-b" }, [
        _c("span", { staticClass: "gray9" }, [_vm._v("收货人：")]),
        _vm._v("王王王")
      ]),
      _c("div", { staticClass: "mar30-b" }, [
        _c("span", { staticClass: "gray9" }, [_vm._v("联系方式：")]),
        _vm._v("123****1234")
      ]),
      _c("div", [
        _c("span", { staticClass: "gray9" }, [_vm._v("收货地址：")]),
        _vm._v("河北省唐山市路北区高新技术开发区太原路与高薪道交叉口")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "f16 goods-list" }, [
      _c("thead", { staticClass: "lin_50 gray9 b_gray2" }, [
        _c("tr", [
          _c(
            "td",
            { staticClass: "pad30-l", staticStyle: { width: "360px" } },
            [_vm._v("货品信息")]
          ),
          _c(
            "td",
            { staticClass: "text-center", staticStyle: { width: "200px" } },
            [_vm._v("价格")]
          ),
          _c(
            "td",
            { staticClass: "text-center", staticStyle: { width: "200px" } },
            [_vm._v("数量")]
          ),
          _c(
            "td",
            { staticClass: "text-center", staticStyle: { width: "200px" } },
            [_vm._v("金额")]
          ),
          _c("td", { staticClass: "pad30-l" }, [_vm._v("优惠信息")])
        ])
      ]),
      _c("tbody", [
        _c("tr", [
          _c("td", { staticClass: "pad30-l flex goods-info pad30-t" }, [
            _c("div", { staticClass: "image100 photo" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://filesouthcdn.nxin.com/nxsc_1604740081548026891902946510415.JPEG?imageView2/1/w/80/h/80"
                }
              })
            ]),
            _c(
              "div",
              {
                staticClass:
                  "mar30-l f14 flex flex-column flex-auto justify-between about"
              },
              [
                _c("div", { staticClass: "ellipsis_two lin_25 name" }, [
                  _vm._v(
                    "三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米"
                  )
                ]),
                _c("div", [_vm._v("规格：元/吨")])
              ]
            )
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("x1")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial fb red" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t pad30-l red" }, [
            _vm._v("直降414元")
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "pad30-l flex goods-info pad30-t" }, [
            _c("div", { staticClass: "image100 photo" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://filesouthcdn.nxin.com/nxsc_1604740081548026891902946510415.JPEG?imageView2/1/w/80/h/80"
                }
              })
            ]),
            _c(
              "div",
              {
                staticClass:
                  "mar30-l f14 flex flex-column flex-auto justify-between about"
              },
              [
                _c("div", { staticClass: "ellipsis_two lin_25 name" }, [
                  _vm._v(
                    "三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米"
                  )
                ]),
                _c("div", [_vm._v("规格：元/吨")])
              ]
            )
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("x1")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial fb red" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t pad30-l red" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pad30-t pad30-l flex" }, [
      _c("div", { staticClass: "mar20-r pad10-tb" }, [
        _vm._v("买家留言(选填)：")
      ]),
      _c("textarea", {
        staticClass: "border pad20 message",
        attrs: { placeholder: "请留下您想对卖家说的话" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mar30-b items-center" }, [
      _c("div", { staticClass: "lable" }, [_vm._v("发票抬头")]),
      _c("input", { staticClass: "border", attrs: { type: "text" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center" }, [
      _c("div", { staticClass: "lable" }, [_vm._v("纳税人识别号")]),
      _c("input", { staticClass: "border", attrs: { type: "text" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex1 border-r" }, [
      _c("div", { staticClass: "flex flex-wrap" }, [
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("发票抬头：2630022541")
        ]),
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("纳税人识别号：W7856456456456456LJ7")
        ]),
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("单位地址：北京市海淀区中关村大厦C座12层1205")
        ]),
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("注册电话：102-4568956")
        ]),
        _c("div", { staticClass: "col" }, [
          _vm._v("开户行：北京市海淀区中关村大厦C座12层")
        ]),
        _c("div", { staticClass: "col" }, [
          _vm._v("银行账户：7895 5548 5787 587")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex items-center f16 justify-end pad30-r single-total" },
      [
        _vm._v("小计："),
        _c("span", { staticClass: "f30 red fb arial" }, [_vm._v("¥9380.00")]),
        _vm._v("（含运费¥0.00元）")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "f16 goods-list" }, [
      _c("thead", { staticClass: "lin_50 gray9 b_gray2" }, [
        _c("tr", [
          _c(
            "td",
            { staticClass: "pad30-l", staticStyle: { width: "360px" } },
            [_vm._v("货品信息")]
          ),
          _c(
            "td",
            { staticClass: "text-center", staticStyle: { width: "200px" } },
            [_vm._v("价格")]
          ),
          _c(
            "td",
            { staticClass: "text-center", staticStyle: { width: "200px" } },
            [_vm._v("数量")]
          ),
          _c(
            "td",
            { staticClass: "text-center", staticStyle: { width: "200px" } },
            [_vm._v("金额")]
          ),
          _c("td", { staticClass: "pad30-l" }, [_vm._v("优惠信息")])
        ])
      ]),
      _c("tbody", [
        _c("tr", [
          _c("td", { staticClass: "pad30-l flex goods-info pad30-t" }, [
            _c("div", { staticClass: "image100 photo" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://filesouthcdn.nxin.com/nxsc_1604740081548026891902946510415.JPEG?imageView2/1/w/80/h/80"
                }
              })
            ]),
            _c(
              "div",
              {
                staticClass:
                  "mar30-l f14 flex flex-column flex-auto justify-between about"
              },
              [
                _c("div", { staticClass: "ellipsis_two lin_25 name" }, [
                  _vm._v(
                    "三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米"
                  )
                ]),
                _c("div", [_vm._v("规格：元/吨")])
              ]
            )
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("x1")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial fb red" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t pad30-l red" }, [
            _vm._v("直降414元")
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "pad30-l flex goods-info pad30-t" }, [
            _c("div", { staticClass: "image100 photo" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://filesouthcdn.nxin.com/nxsc_1604740081548026891902946510415.JPEG?imageView2/1/w/80/h/80"
                }
              })
            ]),
            _c(
              "div",
              {
                staticClass:
                  "mar30-l f14 flex flex-column flex-auto justify-between about"
              },
              [
                _c("div", { staticClass: "ellipsis_two lin_25 name" }, [
                  _vm._v(
                    "三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米三斤玉米"
                  )
                ]),
                _c("div", [_vm._v("规格：元/吨")])
              ]
            )
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial" }, [
            _vm._v("x1")
          ]),
          _c("td", { staticClass: "pad30-t text-center arial fb red" }, [
            _vm._v("¥2030.00")
          ]),
          _c("td", { staticClass: "pad30-t pad30-l red" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pad30-t pad30-l flex" }, [
      _c("div", { staticClass: "mar20-r pad10-tb" }, [
        _vm._v("买家留言(选填)：")
      ]),
      _c("textarea", {
        staticClass: "border pad20 message",
        attrs: { placeholder: "请留下您想对卖家说的话" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mar30-b items-center" }, [
      _c("div", { staticClass: "lable" }, [_vm._v("发票抬头")]),
      _c("input", { staticClass: "border", attrs: { type: "text" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center" }, [
      _c("div", { staticClass: "lable" }, [_vm._v("纳税人识别号")]),
      _c("input", { staticClass: "border", attrs: { type: "text" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex1 border-r" }, [
      _c("div", { staticClass: "flex flex-wrap" }, [
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("发票抬头：2630022541")
        ]),
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("纳税人识别号：W7856456456456456LJ7")
        ]),
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("单位地址：北京市海淀区中关村大厦C座12层1205")
        ]),
        _c("div", { staticClass: "mar20-b col" }, [
          _vm._v("注册电话：102-4568956")
        ]),
        _c("div", { staticClass: "col" }, [
          _vm._v("开户行：北京市海淀区中关村大厦C座12层")
        ]),
        _c("div", { staticClass: "col" }, [
          _vm._v("银行账户：7895 5548 5787 587")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center" }, [
      _c("div", { staticClass: "mar30-r" }, [_vm._v("支付方式")]),
      _c(
        "div",
        { staticClass: "white pointer text-center f14 mar30-r btn selected" },
        [_vm._v("在线支付")]
      ),
      _c("div", { staticClass: "white pointer text-center f14 btn" }, [
        _vm._v("线下结算")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "f16 block mar30-b details" }, [
      _c("div", { staticClass: "pad30 list" }, [
        _c("div", { staticClass: "flex mar30-b" }, [
          _c("span", { staticClass: "flex1" }, [_vm._v("货品总额：")]),
          _c("span", { staticClass: "red arial" }, [_vm._v("¥4350.00")])
        ]),
        _c("div", { staticClass: "flex mar30-b" }, [
          _c("span", { staticClass: "flex1" }, [_vm._v("优惠券抵扣：")]),
          _c("span", { staticClass: "red arial" }, [_vm._v("-¥0.00")])
        ]),
        _c("div", { staticClass: "flex" }, [
          _c("span", { staticClass: "flex1" }, [_vm._v("运费：")]),
          _c("span", { staticClass: "red arial" }, [_vm._v("+¥0.00")])
        ])
      ]),
      _c("div", { staticClass: "pad30 border-t" }, [
        _c("div", { staticClass: "flex items-end justify-end" }, [
          _c("div", { staticClass: "mar10-b" }, [
            _vm._v("应付总额："),
            _c("span", { staticClass: "arial fb f36 red" }, [
              _vm._v("¥4350.00")
            ])
          ]),
          _c("div", { staticClass: "f18 white text-center submit" }, [
            _vm._v("提交订单")
          ])
        ]),
        _c("div", { staticClass: "f14 mar30-t flex justify-end" }, [
          _c("div", { staticClass: "mar20-r" }, [
            _vm._v(
              "寄送至：河北省唐山市路北区高新技术开发区太原路与高薪道交叉口"
            )
          ]),
          _c("div", { staticClass: "mar10-r" }, [_vm._v("收货人：王王王")]),
          _c("div", [_vm._v("123****1234")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }